import {SelectionModelSizeCharacteristic} from './selection-model-size-characteristic';
import {UnitRatingRequest} from './unit-rating-request';
import {UnitRatingResponse} from './unit-rating-response';
import {MotorType} from './motor-type';
import {SelectionSystemType} from './selection-system-type';

export class UnitSelectionCandidate {

  modelSizeCharacteristic!: SelectionModelSizeCharacteristic;
  motorType!: MotorType;
  systemType!: SelectionSystemType;
  coilRowCode!: string;
  ratingRequest!: UnitRatingRequest;
  ratingResponse!: UnitRatingResponse;
  targetDeviation!: number;
  costFactor!: number;

}
